// extracted by mini-css-extract-plugin
export default {"country":"country_country__HQNsP","flag":"country_flag__JZAxK","btn":"country_btn__nwXem"};